/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Agent_Schedules_Awaiting_ApprovalInputs */



/**
* | output |
* | --- |
* | "Awaiting approval: {count}" |
*
* @param {Agent_Schedules_Awaiting_ApprovalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedules_awaiting_approval = /** @type {((inputs: Agent_Schedules_Awaiting_ApprovalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedules_Awaiting_ApprovalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Warten auf Freigabe: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Awaiting approval: ${i?.count}`)
});